import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Subject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TokenService } from '../../core/auth/services/token';
import { BACKGROUND_REQUEST } from '../../core/interceptors/background-request';
import { BusinessNotification, EventRule, NotificationSettings } from './notification.models';

@Injectable({providedIn: 'root'})
export class BusinessNotificationsService {
  private readonly http = inject(HttpClient);
  private readonly tokens = inject(TokenService);
  private readonly base = `${environment.gatewayUrl}/reporting/api/notifications`;
  readonly changed = new Subject<void>();

  get isCompanyAdmin(): boolean {
    return (this.tokens.getDecodedToken()?.realm_access?.roles ?? [])
      .some(role => role === 'ADMIN_ENTREPRISE' || role === 'ROLE_ADMIN_ENTREPRISE');
  }
  inbox(offset = 0, limit = 51, background = false) {
    return this.http.get<BusinessNotification[]>(`${this.base}/inbox`, {
      params: {offset, limit}, context: new HttpContext().set(BACKGROUND_REQUEST, background),
    });
  }
  history(offset = 0, limit = 51) {
    return this.http.get<BusinessNotification[]>(`${this.base}/history`, {params: {offset, limit}});
  }
  markRead(id: string) {
    return this.http.put<void>(`${this.base}/inbox/${encodeURIComponent(id)}/read`, {})
      .pipe(tap(() => this.changed.next()));
  }
  settings() { return this.http.get<NotificationSettings>(`${this.base}/settings`); }
  eventTypes() { return this.http.get<EventRule[]>(`${this.base}/event-types`); }
  saveSettings(settings: NotificationSettings) { return this.http.put<void>(`${this.base}/settings`, settings); }
}
